import { ApolloError } from "@apollo/client";
import { Box } from "@mui/material";
import { Layout } from "components/Layout";
import { usePageTitle } from "hooks/usePageTitle";
import { useNavigate, useRouteError } from "react-router-dom";

import { ErrorDisplay } from "../components/ErrorDisplay";

export function Oops() {
  usePageTitle("Something went wrong");
  const error = useRouteError();
  const apolloError = error as ApolloError;
  const navigate = useNavigate();
  // Show traces only if user isStaff or non-prod environments

  if (!(error instanceof Error)) throw error; // really uncaught because it's not even an error

  const goBack = () => {
    localStorage.removeItem("preLoginPath");
    navigate(-1);
  };

  return (
    <Layout>
      <Box mx="144px">
        <ErrorDisplay error={error} apolloError={apolloError} onAction={goBack} />
      </Box>
    </Layout>
  );
}
